module.exports = __webpack_public_path__ + "img/frame6.d7a2ab91.jpg";